import React, { Component } from "react";
import Select from "react-select";
import Axios from "axios";

export class TypeAhead extends Component {
    state = {
        isClearable: true,
        isDisabled: false,
        isLoading: false,
        isRtl: false,
        isSearchable: true,
        menuIsOpen: false,
        closeMenuOnSelect: true,
        typing: false,
        typingTimeout: 0,
        options: [],
        query: "",
        selectedValue: ""
    };

    getSearch = async search => {
        const response = await Axios.get(
            `/properties/typeToSearch?search=${this.state.query || search}`
        );
        return this.setState({ options: response.data });
    };

    handleOnKeyDown = async event => {
        event.persist();
        const { typing, typingTimeout } = this.state;

        this.setState({
            menuIsOpen: false,
            typing: true
        });
        if (typing) {
            clearTimeout(typingTimeout);
        }

        this.setState({
            typing: false,
            isLoading: true,
            typingTimeout: setTimeout(async() => {
                await this.getSearch();
                this.openMenu();
            }, 1000)
        });
    };

    openMenu = () => {
        this.setState({
            menuIsOpen: true,
            isLoading: false
        });
    };

    handleOnSelect = async event => {
        await this.props.onChange({
            target: {
                name: "property_id",
                value: event?.value
            },
            persist: () => {}
        });
        this.setState({
            selectedValue: event?.value,
            menuIsOpen: false
        });
    };

    render() {
        const {
            state: {
                isClearable,
                isSearchable,
                isLoading,
                menuIsOpen,
                closeMenuOnSelect,
                isRtl,
                isDisabled,
                options,
                selectedValue
            },
            handleOnSelect,
            handleOnKeyDown
        } = this;
        return (
            <Select
                onKeyDown={handleOnKeyDown}
                onInputChange={query => this.setState({ query })}
                value={options.find(({ value }) => String(value) === String(selectedValue))}
                className="basic-single"
                classNamePrefix="select"
                pageSize={20}
                isDisabled={isDisabled}
                isLoading={isLoading}
                closeMenuOnSelect={closeMenuOnSelect}
                menuIsOpen={menuIsOpen}
                isClearable={isClearable}
                isRtl={isRtl}
                isSearchable={isSearchable}
                name={"property_id"}
                options={options}
                onChange={handleOnSelect}
                filterOption={() => true}
                onBlur={() => this.setState({ menuIsOpen: false })}
            />
        );
    }
}
export default TypeAhead;
